import type {CommandSearchContext} from '../types';
import {resolveScopedRoute} from '../scope/resolve-route';
import type {NavigationSearchItem} from './create-navigation-provider';

export interface NavigationAccessServices {
    canAccess?: (accessKey: string) => boolean;
}

/** Returns false when the item is hidden or fails access checks. */
export const isNavigationItemVisible = (
    item: NavigationSearchItem,
    ctx: CommandSearchContext,
): boolean => {
    if (typeof item.hide === 'function' ? item.hide(ctx) : item.hide) {
        return false;
    }

    if (item.canAccess && !item.canAccess(ctx)) {
        return false;
    }

    if (item.accessKey) {
        const services = ctx.services as NavigationAccessServices | undefined;
        if (services?.canAccess && !services.canAccess(item.accessKey)) {
            return false;
        }
    }

    return true;
};

/** Resolves the navigation target for an item in the current context. */
export const resolveNavigationItemTo = (
    item: NavigationSearchItem,
    ctx: CommandSearchContext,
): string | undefined => {
    if (item.resolveTo) {
        return item.resolveTo(ctx);
    }

    if (item.routeTemplate && item.scopeType) {
        return resolveScopedRoute(item.routeTemplate, ctx.scope, item.scopeType);
    }

    return item.to;
};
